import { createSlice } from '@reduxjs/toolkit';

import { tagsApi } from '../../../services/tagsApi';

export type TagType = {
  createdDate: string;
  description: string;
  id: string;
  studentsCount: number;
  tagName: string;
};

export type TagsState = {
  tags: TagType[];
};

const initialState: TagsState = {
  tags: []
};

const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(
      tagsApi.endpoints.fetchTags.matchFulfilled,
      (state, action) => {
        state.tags = action.payload.data;
      }
    );
  }
});

// export const {  } = tagsSlice.actions;

export default tagsSlice.reducer;
